import React,{useState, useEffect} from 'react'
import Arrow from '../../assets/images/arrow.svg'
import { useHistory } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Put, Get } from '../../Api/ApiMethods.js';
import CircularLoader from '../../utils/Loaders/CircularLoader';
import { 
  verifyPhoneOtpUrl,
  rqstOtpForPhoneVerificationUrl,
  getUserDetailsUrl
 } from '../../Routes/ApiRoutes';
 import iconEmailClear from '../../assets/images/emailClear.svg';

export default function VerifyPhone() {
    const history = useHistory()
    const token = useSelector((state) => state.auth.isSignedIn);
    const dispatch = useDispatch();
    const adminDetails = useSelector((state) => state.auth.adminData);
    const [seconds, setSeconds] = useState(3 * 60);
    const [timer, setTimer] = useState('');
    const [isExpired, setIsExpired] = useState(false);
    useEffect(() => {
        if (seconds > 0) {
          let min = Math.floor(seconds/60);
          let sec = seconds - min * 60;
          setTimer((min.toString().length > 1 ? min : '0'+ min)  + ':' + (sec.toString().length > 1 ? sec : '0'+ sec));
          setTimeout(() => setSeconds(seconds - 1), 1000);
        } else {
          setSeconds('OTP Expired!');
          setIsExpired(true)
        }
    })
    const[loader, setLoader] = useState(false);
    const [otpError, setOtpError] = useState(null);

    const [obj ,setObj] = useState({
        "phone": adminDetails.phone,
        "otp": '',
      });

    var handleOtpInput = (e) => {
        let updatedDetails = { ...obj };
        updatedDetails[e.target.id] = e.target.value;
        setObj(updatedDetails)
  
        setOtpError(null);
    }

    const handleSubmit = () => {
      setLoader(true);
        if(! isExpired){
            if(obj.otp === '')
            {
              setLoader(false)
                setOtpError('OTP cannot be blank.')
            }
            if(obj.otp !== '' && !(otpError))
            {
            try {
                Put(verifyPhoneOtpUrl, obj)
                .then(response => {
                    if(response.status === 200)
                    {
                    toast.success("Verification Success.");
                    if (token) {
                      Get(getUserDetailsUrl, token)
                          .then((res) => {
                              if(res.status === 200){
                                  dispatch({
                                      type: 'ADMIN_DATA',
                                      payload: res.data.user,
                                  });
                                  setTimeout(() => history.push(`/profile`) ,2100);
                              }   
                          })
                          .catch((error) => {
                              toast.error(error.error);
                              dispatch({
                                  type: 'SIGN_OUT',
                              });
                              setTimeout(() => history.push(`/login`) ,2100);
                          });
                  }else{
                      dispatch({
                          type: 'SIGN_OUT',
                      });
                      setTimeout(() => history.push(`/login`) ,2100);
                  }
                  }
                  
                })
                .catch(error => {
                  setLoader(false)
                  toast.error(error.error)
                })
              }catch (error) {
                setLoader(false)
                console.log(error);
                toast.error(error.error)
              }
            }
        }
        else{
          setLoader(false)
            toast.error("OTP expired. Please try again.")
        }
    }

    const VerifyPhone = () => {
      setLoader(true)
        try {
            Put(rqstOtpForPhoneVerificationUrl, { 'phone' : adminDetails.phone})
            .then(response => {
                if(response.success)                
                {       
                  toast.success("OTP resend.")
                  setSeconds(3*60);
                  setLoader(false)
                  setIsExpired(false);
                }
            })
            .catch(error => {
              toast.error(error.error)
            })
          }catch (error) {
            console.log(error);
          }
    }

    return (
    <>
      {loader && <CircularLoader />}
        <section class="sign-in-wrapper Forgot-Wpassword">
            <div class="container">
                <div class="sign-in">
                <h3> 
                  <span>Verify phone</span>
                </h3>
                <p>Enter the verification code sent to <br/> {adminDetails.phone}.</p>
            
                <div class="form-group">
                    <img className='inputImage' style={{visibility : obj.otp === "" ? 'hidden' : 'visible'}} 
                      alt='otpClear' src={iconEmailClear} onClick={() => {
                        let updatedDetails = { ...obj };
                        updatedDetails['otp'] = '';
                        setObj(updatedDetails)
                        setOtpError(null);
                      }} />
                   <input className={otpError ? "form-control borderRed" : "form-control" } onChange={(e) => handleOtpInput(e)} 
                        value={obj.otp} id='otp' type="password" placeholder="OTP" />
                   {otpError && <span className='form-error'>{otpError}</span>}
                </div>
           
            <div class="re-send">
                <p class="resend-btn">
                {isNaN(seconds) && <a className='link' onClick={VerifyPhone}>Resend</a>}
                </p>
                <p class="time"> {isNaN(seconds) ? seconds : timer }</p>
            </div>
            <div class="comman-btn">
                <button onClick={() => handleSubmit()}>Submit</button>
            </div> 
        </div>
        </div>
    </section>
    
    </>)
}
